import { useState, useEffect, useRef } from 'react';
import ClipLoader from "react-spinners/PacmanLoader";
import { Container } from 'react-bootstrap';
import { Sida, Rubrik, ContentWrapper} from "../pages/ContentStyles";
import {Buffer} from 'buffer';

export default function useGetBackend(url) {
    const [data, setData] = useState([]);
    const [loading, setLoadning] = useState(true);

    const [resultVariant, setResultVariant] = useState(null);
    const [resultText,    setResultText]    = useState(null);
    const [resultVisible, setResultVisible] = useState(null);
    const [resultSuccess, setResultSuccess] = useState(true);

    var queryParam = useRef("");

    function Refresh(pageIndex=0, pageSize=25) {
        setLoadning(true);
        init(pageIndex, pageSize);
    }

    function Seek(QueryParam) {
        queryParam.current = QueryParam;
        init();
    }

    async function init(pageIndex=0, pageSize=25) {
        //setLoadning(true);
        try {
            var query = queryParam.current;
            if (query.includes('?') || url.includes('?')) {
                query=query+"&"+ "pageSize="+pageSize+"&pageIndex="+pageIndex;
            } else {
                query="?pageSize="+pageSize+"&pageIndex="+pageIndex;
            }

            const response = await fetch(url + query, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization':'Bearer '+ localStorage.getItem('access_token'),
                },
            });

            if (response.status === 401) {
                window.location.href = "/login";                    
            }

            if (response.ok) {
                const json = await response.json();
                setResultVariant('success');
                setResultVisible(false);
                setResultText('');
                setData(json);
            } else {
                setResultVariant('warning');
                setResultVisible(true);
                setResultText('Ett fel uppstod!!');

                throw response;
            }
            
        }
        catch (e) {
            setResultVariant('warning');
            setResultVisible(true);
            setResultText('Ett fel uppstod!!!');
            setResultSuccess(false);
        }
        finally {
            setLoadning(false);
        }
    }

    useEffect(() => {init()}, [url]); 

    return { resultVariant, resultVisible, resultText, resultSuccess, loading, data, Refresh, Seek }; 
}

function parseJwt (token) {
    var payload =  token.split('.')[1];    
    return Buffer.from(payload, 'base64').toString().replaceAll('http://schemas.xmlsoap.org/ws/2005/05/identity/claims/','');
}

export function UserData()  {
    var access_token = localStorage.getItem('access_token');
    
    if (access_token !=null && access_token.length!="") {
        var parsed_payload = parseJwt(access_token);
        var token = JSON.parse(parsed_payload);
        const IsLoggedIn = (token.sub.toString().length==36)?true:false;
        return { token, IsLoggedIn  }
    } else {
        var token = [];
        const IsLoggedIn = false;
        return { token, IsLoggedIn  }
    }
}

export async function CallAPI(url, method = 'GET', body = {}) {
    var errorsException = false, resultVariant, resultVisible, resultText="...";
    var jsondata;
    try {
        
        let content = {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'Authorization':'Bearer '+ localStorage.getItem('access_token'),
            },            
        };

        if (method!='GET') content.body = body;

        const response =  await fetch(url, content);

        if (response.ok) {
            jsondata =  await response.json();
            
            resultVisible=true;
            
            resultText=jsondata.resultText;
            if (resultText=="") resultVisible = false;

            if (jsondata.errorsException) {
                errorsException = true;
                resultVariant ="warning";    
            } else {
                errorsException = false;
                resultVariant ="success";
            }

        } else {
            errorsException = true;
            resultVariant ="warning";
            resultVisible=true;
            resultText= 'Ett fel uppstod!';
        }
    }
    catch (e) {
        console.log(e);
        errorsException = true;
        resultVariant ="warning";
        resultVisible=true;
        resultText= 'Ett fel uppstod!!';
    }
    finally {

    }
    return { resultVariant, errorsException, resultVisible, resultText, jsondata }; 
}

export async function CallDownload(url) {
    var filedata;
    try {
        const response =  await fetch(url, {
            method: "GET",
            headers: {
                'Authorization':'Bearer '+ localStorage.getItem('access_token'),
            }
        });

        if (response.ok) {
            const content = await response.blob();
            console.log(content.size);
            filedata=content;
        }
    }
    catch (e) {
    }
    finally {

    }
    return filedata; 
}

export function LogOff() {
    localStorage.setItem('access_token', "");
    window.location.href = "/login";
}

export function Spinner() {
    let [color, setColor] = useState(process.env.REACT_APP_BrandColor);

    return (
        <div className="Spinner">
        <ClipLoader color={process.env.REACT_APP_BrandColor}  size={30} /><br></br>
        </div>
    )
};        